import Modal from 'react-modal';
import "../../styles/AdminPage.css";
import PropTypes from 'prop-types';
import React from 'react';
import Button, { BUTTON_TYPES } from '../Button';
import { useNavigate } from 'react-router-dom';
import { FaTimes } from "react-icons/fa";

Modal.setAppElement('#root');

const AttendanceModal = ({ isOpen, onClose, event }) => {
    const navigate = useNavigate();

    const goToMembers = (event) => {
        navigate('/admin/members', { state: { selectedEvent: event } });
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="QR Code Modal"
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
        >
            <>
                <div className='d-flex flex-row justify-content-between align-items-center mb-4'>
                    <h3 className="text-start mb-0">{event.eventName} Attendance</h3>
                    <div className='d-flex flex-row justify-content-end align-items-center me-1'>
                        <button className="close-btn" onClick={onClose}>{<FaTimes />}</button>
                    </div>
                </div>
                <div className='scrollable-container text-start fs-4 py-1 px-3'>
                    {event.visitorsAttended && event.visitorsAttended.map((visitor, index) => (
                        <div key={`visitor-${index}`} className='mb-1'>
                            {visitor.firstName} {visitor.lastName}(Not Registered)
                        </div>
                    ))}
                    {event.membersAttended && event.membersAttended.map((member, index) => (
                        <div key={`member-${index}`} className='mb-1'>
                            {member.firstName} {member.lastName}
                        </div>
                    ))}
                </div>
                <Button
                    id="attendance-button-modal"
                    type={BUTTON_TYPES.primary}
                    buttonText="View Breakdown"
                    action={() => {
                        onClose();
                        goToMembers(event);
                    }}
                />
            </>
        </Modal>
    );
};

AttendanceModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    event: PropTypes.object
};

export default AttendanceModal;
